import Flatpickr from 'flatpickr'

function isScrollInsideCalendar(event, instance) {
  return !!(instance.calendarContainer && event.target && instance.calendarContainer.contains(event.target))
}

function removeScrollHandler(instance) {
  if (instance._closeOnScrollHandler) {
    window.removeEventListener('scroll', instance._closeOnScrollHandler, true)
    instance._closeOnScrollHandler = null
  }
}

Flatpickr.setDefaults({
  onOpen: [
    function (selectedDates, dateStr, instance) {
      instance._closeOnScrollHandler = function (event) {
        if (isScrollInsideCalendar(event, instance)) {
          return
        }

        instance.close()
      }

      window.addEventListener('scroll', instance._closeOnScrollHandler, true)
    }
  ],
  onClose: [
    function (selectedDates, dateStr, instance) {
      removeScrollHandler(instance)
    }
  ],
  onDestroy: [
    function (selectedDates, dateStr, instance) {
      removeScrollHandler(instance)
    }
  ]
})
